import { render, staticRenderFns } from "./widgetTagsViewer.vue?vue&type=template&id=5ed1ded4&scoped=true"
import script from "./widgetTagsViewer.vue?vue&type=script&lang=js"
export * from "./widgetTagsViewer.vue?vue&type=script&lang=js"
import style0 from "./widgetTagsViewer.vue?vue&type=style&index=0&id=5ed1ded4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1ded4",
  null
  
)

export default component.exports